import { render, staticRenderFns } from "./PrizePicture.vue?vue&type=template&id=6835a172&scoped=true&"
import script from "./PrizePicture.vue?vue&type=script&lang=js&"
export * from "./PrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizePicture.vue?vue&type=style&index=0&id=6835a172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835a172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6835a172')) {
      api.createRecord('6835a172', component.options)
    } else {
      api.reload('6835a172', component.options)
    }
    module.hot.accept("./PrizePicture.vue?vue&type=template&id=6835a172&scoped=true&", function () {
      api.rerender('6835a172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/PrizePicture.vue"
export default component.exports